module.exports = __webpack_public_path__ + "static/media/graph_inner.2133c193.png";